export const AppActionTypes = {
  SET_SHOW_KOVA_STAGE: 'SET_SHOW_KOVA_STAGE',
  TOGGLE_SIDE_MENU: 'TOGGLE_SIDE_MENU',
  TOGGLE_RESET_VIEW: 'TOGGLE_RESET_VIEW',
  SET_OPTION_MENU_TO_DISPLAY: 'SET_OPTION_MENU_TO_DISPLAY',
  TOGGLE_TRIGGER_PRINT: 'TOGGLE_TRIGGER_PRINT',
  SET_DOWNLOAD_URL: 'SET_DOWNLOAD_URL',
};
